// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__cbnSw","shimmer":"styles_shimmer__aNgY5"};